import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import Navemenu from '../Navemenu/Navemenu';
import Footer from '../Footer/Footer';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import './BlogDetail.scss';

const BlogDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [relatedBlogs, setRelatedBlogs] = useState([]);

  // Fix: Navmenu ko properly handle karo
  useEffect(() => {
    // Navmenu ke icons ka color black karo, logo ko untouched rakhna hai
    const updateNavMenu = () => {
      const navElement = document.querySelector('nav');
      const headerElement = document.querySelector('header');
      
      if (navElement) {
        // Navbar ke styling classes
        navElement.classList.remove('transparent', 'navbar-transparent');
        navElement.classList.add('solid', 'navbar-solid');
        navElement.style.backgroundColor = '#ffffff';
        navElement.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';
        
        // Icons ka color black karo (with delay for DOM readiness)
        setTimeout(() => {
          // All nav icons select karo
          const navIcons = document.querySelectorAll('nav i, nav svg, nav .icon, nav [class*="icon-"], nav .material-icons, nav .fa, nav .fas, nav .far, nav .fab');
          const navLinks = document.querySelectorAll('nav a:not(.logo):not(.navbar-brand):not([class*="logo"])');
          const navTexts = document.querySelectorAll('nav .nav-link, nav .menu-item, nav .nav-item > a');
          
          // Icons ko black karo
          navIcons.forEach(icon => {
            icon.style.color = '#000000';
            icon.style.fill = '#000000';
            icon.classList.add('black-icon');
          });
          
          // Nav links ka text bhi black karo (optional)
          navLinks.forEach(link => {
            link.style.color = '#000000';
          });
          
          navTexts.forEach(text => {
            text.style.color = '#000000';
          });
          
          // Logo ko untouched rakhne ke liye - IMPORTANT
          const logoElements = document.querySelectorAll('nav .logo, nav .navbar-brand, nav [class*="logo"], nav .logo-container');
          logoElements.forEach(logo => {
            logo.style.color = ''; // Reset color
            logo.style.filter = ''; // Reset filter
            
            // Logo ke andar ke icons/child elements ko bhi reset karo
            const logoChildren = logo.querySelectorAll('*');
            logoChildren.forEach(child => {
              child.style.color = '';
              child.style.fill = '';
            });
            
            // Agar logo image hai
            const logoImg = logo.querySelector('img');
            if (logoImg) {
              logoImg.style.filter = 'none';
              logoImg.style.color = '';
            }
          });
          
        }, 150);
      }
      
      if (headerElement) {
        headerElement.style.backgroundColor = '#ffffff';
      }
    };

    // Add CSS style for icons globally for this page
    const styleTag = document.createElement('style');
    styleTag.id = 'blog-detail-nav-styles';
    styleTag.innerHTML = `
      /* Nav menu icons ko black karo for blog detail page */
      .blog-detail-page nav i,
      .blog-detail-page nav svg,
      .blog-detail-page nav .icon,
      .blog-detail-page nav [class*="icon"],
      .blog-detail-page nav .material-icons,
      .blog-detail-page nav .fa,
      .blog-detail-page nav .fas,
      .blog-detail-page nav .far,
      .blog-detail-page nav .fab {
        color: #000000 !important;
        fill: #000000 !important;
      }
      
      /* Nav links text ko bhi black karo */
      .blog-detail-page nav a:not(.logo):not(.navbar-brand):not([class*="logo"]),
      .blog-detail-page nav .nav-link,
      .blog-detail-page nav .menu-item > a {
        color: #000000 !important;
      }
      
      /* Logo ko exempt karo - IMPORTANT */
      .blog-detail-page nav .logo,
      .blog-detail-page nav .navbar-brand,
      .blog-detail-page nav [class*="logo"],
      .blog-detail-page nav .logo-container,
      .blog-detail-page nav .logo img,
      .blog-detail-page nav .logo * {
        color: inherit !important;
        filter: none !important;
        fill: inherit !important;
      }
      
      /* Logo image ka special case */
      .blog-detail-page nav .logo img {
        filter: none !important;
      }
    `;
    document.head.appendChild(styleTag);

    // Initial update
    updateNavMenu();
    
    // Scroll event pe bhi update karo
    window.addEventListener('scroll', updateNavMenu);
    
    // Thodi der baad phir update (ensure ho jaye)
    const timer = setTimeout(updateNavMenu, 500);
    
    // Scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
    // Fetch data
    if (id) {
      fetchBlog();
      fetchRelatedBlogs();
    }
    
    // Cleanup
    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', updateNavMenu);
      
      // Remove the style tag we added
      const existingStyle = document.getElementById('blog-detail-nav-styles');
      if (existingStyle) {
        document.head.removeChild(existingStyle);
      }
      
      // Reset nav styles on unmount
      const navElement = document.querySelector('nav');
      if (navElement) {
        navElement.classList.remove('solid', 'navbar-solid');
        navElement.style.backgroundColor = '';
        navElement.style.boxShadow = '';
      }
    };
  }, [id]);

  // WordPress API URL
  const WORDPRESS_API = 'https://lavenderblush-louse-758819.hostingersite.com/blog/wp-json/wp/v2';

  // Fetch single blog post
  const fetchBlog = async () => {
    try {
      setLoading(true);
      setError(null);
      
      console.log('Fetching blog with ID/Slug:', id);
      
      let response;
      if (!isNaN(id)) {
        // Fetch by post ID
        response = await axios.get(`${WORDPRESS_API}/posts/${id}?_embed`, {
          timeout: 10000,
          headers: {
            'Accept': 'application/json',
          }
        });
      } else {
        // Fetch by slug
        response = await axios.get(`${WORDPRESS_API}/posts?slug=${id}&_embed`, {
          timeout: 10000,
          headers: {
            'Accept': 'application/json',
          }
        });
        
        if (response.data && response.data.length > 0) {
          response.data = response.data[0];
        } else {
          throw new Error('Blog not found');
        }
      }
      
      console.log('Blog data received:', response.data);
      setBlog(response.data);
      setLoading(false);
      
    } catch (err) {
      console.error('Error fetching blog:', err);
      setError('Failed to load blog post. Please check your connection and try again.');
      setLoading(false);
      setBlog(null);
    }
  };

  // Fetch related blogs from WordPress
  const fetchRelatedBlogs = async () => {
    try {
      const response = await axios.get(`${WORDPRESS_API}/posts?_embed&per_page=3&exclude=${id}`, {
        timeout: 8000
      });
      
      if (response.data && response.data.length > 0) {
        setRelatedBlogs(response.data);
      } else {
        // Agar WordPress mein posts kam hai toh exclude mat karo
        const allPosts = await axios.get(`${WORDPRESS_API}/posts?_embed&per_page=4`);
        const filteredPosts = allPosts.data.filter(post => post.id != id).slice(0, 3);
        setRelatedBlogs(filteredPosts);
      }
    } catch (err) {
      console.log('Could not fetch related blogs:', err.message);
      setRelatedBlogs([]);
    }
  };

  // Format date
  const formatDate = (dateString) => {
    try {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateString).toLocaleDateString('en-US', options);
    } catch (e) {
      return '';
    }
  };

  // Strip HTML tags
  const stripHtml = (html) => {
    if (!html) return '';
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  };

  // Get featured image
  const getFeaturedImage = (post) => {
    if (post._embedded && 
        post._embedded['wp:featuredmedia'] && 
        post._embedded['wp:featuredmedia'][0] &&
        post._embedded['wp:featuredmedia'][0].source_url) {
      return post._embedded['wp:featuredmedia'][0].source_url;
    }
    // Fallback image - TGB theme color
    return 'https://images.unsplash.com/photo-1558981403-c5f9899a28bc?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&h=600&q=80';
  };

  // Get excerpt
  const getExcerpt = (content, length = 150) => {
    const text = stripHtml(content);
    if (text.length > length) {
      return text.substring(0, length) + '...';
    }
    return text;
  };

  // Get category
  const getCategory = (post) => {
    if (post._embedded && 
        post._embedded['wp:term'] && 
        post._embedded['wp:term'][0] && 
        post._embedded['wp:term'][0].length > 0) {
      return post._embedded['wp:term'][0][0].name;
    }
    return 'Biking';
  };

  // Get author name
  const getAuthorName = (post) => {
    if (post._embedded && post._embedded.author && post._embedded.author[0]) {
      return post._embedded.author[0].name;
    }
    return 'The Good Biker';
  };

  if (loading) {
    return (
      <div className="cmsPagesWrapper">
        <Navemenu />
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading blog post...</p>
        </div>
        <Footer />
      </div>
    );
  }

  if (error || !blog) {
    return (
      <div className="cmsPagesWrapper">
        <Navemenu />
        <div className="error-container">
          <h2>Blog Not Found</h2>
          <p>{error || 'The blog post you are looking for does not exist.'}</p>
          <button onClick={() => navigate('/blogs')} className="retry-btn">
            Back to Blogs
          </button>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="blog-detail-page">
      {/* Navmenu ko prop pass karo agar supported hai */}
      <Navemenu />
      
      <Helmet>
        <title>{stripHtml(blog.title.rendered)} - The Good Biker</title>
        <meta name='description' content={getExcerpt(blog.content.rendered, 160)} />
        <meta name='keywords' content='motorcycle blog, biking article' />
      </Helmet>

      {/* Main Blog Content */}
      <div className="container">
        <div className="blog-content-wrapper">
          
          {/* Blog Image */}
          <div className="blog-featured-image">
            <img 
              src={getFeaturedImage(blog)} 
              alt={stripHtml(blog.title.rendered)} 
              className="img-fluid"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = 'https://images.unsplash.com/photo-1558981403-c5f9899a28bc?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=400&q=80';
              }}
            />
          </div>
          
          {/* Blog Title */}
          <h1 className="blog-title" dangerouslySetInnerHTML={{ __html: blog.title.rendered }} />
          
          {/* Blog Date */}
          <div className="blog-date">
            <i className="far fa-calendar"></i> {formatDate(blog.date)}
          </div>
          
          {/* Blog Content */}
          <div 
            className="blog-content" 
            dangerouslySetInnerHTML={{ __html: blog.content.rendered }} 
          />
          
          {/* Back Button */}
          <div className="blog-back-btn">
            <Link to="/blogs" className="back-to-blogs">
              <i className="fas fa-arrow-left"></i> Back to All Blogs
            </Link>
          </div>
          
        </div>
      </div>

      {/* You May Also Like - Only if we have related blogs */}
      {relatedBlogs.length > 0 && (
        <div className="related-blogs-section">
          <div className="container">
            <h2 className="section-title">You May Also Like</h2>
            <div className="related-blogs-grid">
              {relatedBlogs.map((relatedBlog) => (
                <div className="related-blog-card" key={relatedBlog.id}>
                  <div className="related-blog-image">
                    <img 
                      src={getFeaturedImage(relatedBlog)} 
                      alt={stripHtml(relatedBlog.title.rendered)}
                      className="img-fluid"
                    />
                  </div>
                  <div className="related-blog-content">
                    <h3 dangerouslySetInnerHTML={{ __html: relatedBlog.title.rendered }} />
                    <div className="related-blog-date">
                      <i className="far fa-calendar"></i> {formatDate(relatedBlog.date)}
                    </div>
                    <p className="related-blog-excerpt">
                      {getExcerpt(relatedBlog.content.rendered, 100)}
                    </p>
                    <Link to={`/blogs/${relatedBlog.slug || relatedBlog.id}`} className="read-more-btn">
                      Read More
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default BlogDetail;